// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle, Loader } from 'lucide-react';
import notificationService from '../utils/notificationService';
import './ToastProvider.css';

const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    // Écouter les notifications du service centralisé
    const unsubscribe = notificationService.addListener((newToasts) => {
      setToasts(newToasts);
    });

    return unsubscribe;
  }, []);

  const getToastIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={16} />;
      case 'error':
        return <AlertCircle size={16} />;
      case 'warning':
        return <AlertTriangle size={16} />;
      case 'loading':
        return <Loader size={16} className="animate-spin" />;
      default:
        return <Info size={16} />;
    }
  };

  const getToastClass = (type) => {
    switch (type) {
      case 'success':
        return 'toast-success';
      case 'error':
        return 'toast-error';
      case 'warning':
        return 'toast-warning';
      case 'loading':
        return 'toast-loading';
      default:
        return 'toast-info';
    }
  };

  return (
    <>
      {children}
      
      {/* Container des toasts */}
      <div className="toast-container">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`toast ${getToastClass(toast.type)}`}
            style={{
              animation: 'slideInRight 0.3s ease-out'
            }}
          >
            <div className="toast-icon">
              {getToastIcon(toast.type)}
            </div>
            
            <div className="toast-content">
              <div className="toast-message">
                {toast.message}
              </div>
              <div className="toast-timestamp">
                {new Date(toast.timestamp).toLocaleTimeString('fr-FR', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </div>
            </div>
            
            {toast.type !== 'loading' && (
              <button
                className="toast-close"
                onClick={() => {
                  // Utiliser le service de notifications pour supprimer
                  notificationService.removeToast(toast.id);
                }}
                aria-label="Fermer la notification"
              >
                <X size={16} />
              </button>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ToastProvider;
